import styled from "styled-components";

export const SingleImgContainer = styled.div`
  .main-container{
    img{
      width:100%;
    }
  }
  
`